import { memo } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Typography } from 'common/typography'
import useNearScreen from 'hooks/use-near-screen'
import { useLessons } from 'querys/lesson'
import LessonItem from './lesson-item'

const ModuleStyled = styled.section`
  .module-title {

  }
  @media (min-width: 768px) {
    .module-title {

    }
  }
`

function Module({
  title, classes, chapterIdx, badges, consecutiveLessonsCompleted, progress, lessonWidthBadge,
}) {
  const { data: chapters } = useLessons()
  const initalLesson = chapters.map((item, idx) => (idx < chapterIdx ? item.lessons.length : 0)).reduce((accumulator, currentValue) => accumulator + currentValue)

  const [show, element] = useNearScreen({ rootMargin: '0px 0px 20% 0px' })
  return (
    <ModuleStyled ref={element} aria-label={title}>
      <div className="module-title" data-cy="chapter-title">
        <Typography small="regular" large="headline5" as="h2" color="var(--baseNeutral)">
          {title}
        </Typography>
      </div>
      {show && classes?.map((lesson, idx) => (
        <LessonItem
          badgeState={badges.find((item) => item.lesson === idx + initalLesson + 1)}
          lessonWidthBadge={lessonWidthBadge}
          progress={progress}
          key={lesson.uuid}
          numberLesson={idx + initalLesson + 1}
          consecutiveLessonsCompleted={consecutiveLessonsCompleted}
          {...lesson}
        />
      ))}
    </ModuleStyled>
  )
}


Module.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      title: PropTypes.string,
      slug: PropTypes.string,
      content: PropTypes.object,
      total_duration: PropTypes.number,
      completed: PropTypes.bool,
      has_access: PropTypes.bool,
      video: PropTypes.object,
    }),
  ).isRequired,
}

const ModuleMemo = memo(Module)

export default ModuleMemo
